/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { shallowEqual, useSelector } from "react-redux";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url) => {
    return checkIsActive(location, url)
      ? " menu-item-active menu-item-open "
      : "";
  };

  const { user } = useSelector(
    (state) => ({ user: state.auth.user }),
    shallowEqual
  );
  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>

        <li className={`menu-item ${getMenuItemActive("/app/customers")}`} aria-haspopup="true" >
          <NavLink className="menu-link" to="/app/customers">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Home.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        {user && (user.admin_type === "SUPER_ADMIN" || user.admin_type === "ADMIN") ?
          <li className={`menu-item ${getMenuItemActive("/app/User")}`} aria-haspopup="true" >
            <NavLink className="menu-link" to="/app/User">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
              </span>
              <span className="menu-text">Users</span>
            </NavLink>
          </li>
          :
          <></>
        }
         {user && (user.admin_type === "SUPER_ADMIN") ?
          <li className={`menu-item ${getMenuItemActive("/app/maps")}`} aria-haspopup="true" >
            <NavLink className="menu-link" to="/app/maps">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Map/Marker2.svg")} />
              </span>
              <span className="menu-text">Maps</span>
            </NavLink>
          </li>
          :
          <></>
        }

        {user && user.admin_type === "SUPER_ADMIN" ?
          <li className={`menu-item menu-item-submenu ${getMenuItemActive("/app/settings")}`} aria-haspopup="true" data-menu-toggle="hover" >
            <NavLink className="menu-link menu-toggle" to="/app/settings">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Settings4.svg")} />
              </span>
              <span className="menu-text">Settings</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">Settings</span>
                  </span>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/app/ManageTown"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/app/ManageTown">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Manage Town Councils</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/app/ManageAreas"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/app/ManageAreas">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Manage Areas</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/app/ManageBlocks"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/app/ManageBlocks">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Manage Blocks</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/app/devices"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/app/devices">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Manage Devices</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/app/SensorMonitoringVariable"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/app/SensorMonitoringVariable">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Device Monitoring Variables</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/app/SensorControlVariable"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/app/SensorControlVariable">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Device Control Variables</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/app/global-settings/"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/app/global-settings/">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Global Settings</span>
                  </NavLink>
                </li>
{/* 
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/app/global-settings/"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/app/import/SensorMonitoringVariable">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Import Monitoring Variables</span>
                  </NavLink>
                </li> */}

                
              </ul>
            </div>
          </li>
          :
          <></>
        }

        <li className={`menu-item logout_button_sidebar`} aria-haspopup="true" >
          <NavLink className="menu-link" to="/logout">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Sign-out.svg")} />
            </span>
            <span className="menu-text">Logout</span>
          </NavLink>
        </li>
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
